export class MessageType{
  public static msgError:string   = 'ERROR';
  public static msgWarning:string = 'WARNING';
  public static msgMessage:string = 'MESSAGE';
  public static msgSuccess:String = 'SUCCESS';
  public static readonly msgSuccessful:string = 'Successful';
  public static msgCancel:String  = 'CANC';
  public static readonly msgFailure:string = 'FAILURE';
}

export class PickManagementConstants{
  public static unpickAction = 'UnPick';
  public static unpickUnallocate = 'UnPickAlloc';
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/models/message-type.config.ts